<div class="notif-bell-wrap">
  <button class="layout-topbar-action notif-bell-btn" [class.is-ringing]="svc.isRinging()" (click)="toggle($event)" pTooltip="Notifications" tooltipPosition="bottom">
    <i class="fa-light fa-bell"></i>
    @if (svc.unreadCount() > 0) {
      <span class="notif-badge">{{ svc.unreadCount() > 99 ? '99+' : svc.unreadCount() }}</span>
    }
  </button>
</div>

<p-overlayPanel #notifPanel appendTo="body" styleClass="notif-panel">
  <div class="notif-panel-header">
    <span class="notif-panel-title">Notifications</span>
    @if (svc.unreadCount() > 0) {
      <button class="notif-mark-all" (click)="svc.markAllAsRead()">Tout marquer comme lu</button>
    }
  </div>

  @if (svc.loading()) {
    <div class="notif-loading">Chargement...</div>
  } @else if (!svc.notifications().length) {
    <div class="notif-empty">
      <i class="fa-light fa-bell-slash"></i>
      <span>Aucune notification</span>
    </div>
  } @else {
    <div class="notif-list">
      @for (n of svc.notifications(); track n.id) {
        <button class="notif-item" [class.notif-item--unread]="!n.read_at" (click)="open(n)">
          <div class="notif-icon" [style.color]="eventColor(n)">
            <i [class]="eventIcon(n)"></i>
          </div>
          <div class="notif-content">
            <div class="notif-title">{{ n.title }}</div>
            <div class="notif-body">{{ n.body }}</div>
            <div class="notif-time">{{ relativeTime(n.created_at) }}</div>
          </div>
          @if (!n.read_at) {
            <span class="notif-dot"></span>
          }
        </button>
      }
    </div>
    <a class="notif-see-all" routerLink="/moni/settings/notifications" (click)="notifPanel.hide()">
      Gérer les préférences
    </a>
  }
</p-overlayPanel>
